import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgPanelLeftLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M14.4627 1L3.5 12.1101L14.4627 23M20.5 1L9.53729 12.1101L20.5 23"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgPanelLeftLarge.displayName = 'SvgPanelLeftLarge';
const PanelLeftLarge = withForgeIconProps(SvgPanelLeftLarge, {
  name: 'PanelLeft',
  usage: 'Use to open a panel to the left.',
  related: 'flyout, pane',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'large',
});
export default PanelLeftLarge;
